import { render, staticRenderFns } from "./AssignGroupsToLessons.vue?vue&type=template&id=2537af46"
import script from "./AssignGroupsToLessons.vue?vue&type=script&lang=js"
export * from "./AssignGroupsToLessons.vue?vue&type=script&lang=js"
import style0 from "./AssignGroupsToLessons.vue?vue&type=style&index=0&id=2537af46&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2537af46')) {
      api.createRecord('2537af46', component.options)
    } else {
      api.reload('2537af46', component.options)
    }
    module.hot.accept("./AssignGroupsToLessons.vue?vue&type=template&id=2537af46", function () {
      api.rerender('2537af46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssignGroupsToLessons.vue"
export default component.exports